<template>
<div
    v-if="profile != null"
>
    <m-restricted-field
        v-if="this.$rc.$state.isAuthActorSystemAdmin()"
    >
        <v-select
            label="State"
            :items="$rc.enumChoices('numbering_plan_state',false)"
            :value="profile.numbering_plan.state"
            style="margin-bottom: 15px"
            v-on:change="onChangeState"
        />
    </m-restricted-field>

    <div
        :style="$rc.styleInputLabel()"
    >
        Phone Number Plan
    </div>

    <div
        v-html="plan_body"
        style="margin-top: 15px"
    >
    </div>

    <div
        style="text-align: right; margin-top: 15px;"
        v-if="this.$rc.$state.isAuthActorSystemAdmin()"
    >
        <m-restricted-button
            v-on:click="onClickEditPlan"
        >
            Edit Plan...
        </m-restricted-button>

        <v-row>
            <v-col>
                <v-switch
                    label="Hosting messaging (RedChirp enabling texting on existing landlines)"
                    v-model="profile.numbering_plan.hosted_messaging"
                    v-on:change="save"
                />
            </v-col>
            <v-col>

                <v-select
                    label="LOA Signature State (admins only)"
                    v-if="profile.numbering_plan.hosted_messaging"
                    :items="$rc.enumChoices('numbering_plan_loa_state',false)"
                    v-model="profile.numbering_plan.hosted_messaging_loa_state"
                    v-on:change="save"
                />
            </v-col>
        </v-row>
    </div>


     <m-organization-event-card
        :value="profile.event_numbering_plan"
        style="margin-bottom: 15px; margin-top: 15px;"
        v-on:update="$emit('update')"
    />

    <div
        style="margin-top: 15px"
        v-if="profile.numbering_plan.hosted_messaging && profile.numbering_plan.state != 'complete'"
    >
        This section will remain un-checked even after you e-sign the Letter of Authorization above because our team still has some work to do! We will mark this section as complete once we order the services, receive them (which takes 24-48 hours), and fully test them for you.
    </div>

</div>
</template>

<script>
export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },
    },

    methods: {
        onClickEditPlan() {
            this.$rc.prompt({
                'title' : 'Edit phone number plan',
                'label' : 'Plan',
                'value' : this.plan_body_plain_text,
                'textarea': true,
                'allow_blank': true,
                'after_prompt' : (value) => {
                    this.doUpdatePlan(value);
                }
            });
        },

        doUpdatePlan(value)
        {
            this.profile.numbering_plan.body = value;
            this.save();
        },

        onChangeState(new_state)
        {
            this.profile.numbering_plan.state = new_state;
            this.save();
        },

        save()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/numbering-plan',

                'params' : this.profile.numbering_plan,

                'on_success': (data) => {
                        this.dialog = false;
                        this.$emit('update-profile',data);
                    },

                'on_error': 'Unable to save numbering plan',
            });
        },
    },

    computed: {
        hide_plan() {
            if ( this.profile == null )
                return false;

            if ( this.profile.numbering_plan.state != 'in-progress' ) return false;
            if ( this.profile.numbering_plan.body == null ) return false;

            if ( this.profile.numbering_plan.body.toLowerCase().includes('calendly') )
                return true;

            return false;
        },

        plan_body()
        {
            let body = this.$rc.getDeep(this.profile,'numbering_plan/body');

            if ( body == null || body.trim().length == 0 )
            {
                return 'No plan entered';
            }

            return this.$rc.wrapHTML(body);
        },

        plan_body_plain_text()
        {
            let body = this.$rc.getDeep(this.profile,'numbering_plan/body');

            if ( body == null || body.trim().length == 0 )
            {
                return '';
            }

            return body;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>